import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.select = new window.TomSelect(this.element, {
      valueField: "id",
      labelField: "text",
      searchField: "text",
      loadThrottle: 300,
      load: (query, callback) => this.load(query, callback)
    })
  }

  disconnect() {
    this.select?.destroy()
    this.select = null
  }

  load(query, callback) {
    if (!query.length) return callback()

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)

    fetch(url, { headers: { Accept: "application/json" } })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((json) => callback(json.data))
      .catch(() => callback())
  }
}
